Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NavigationContext = void 0;
var _react = require("react");
var missingNavigationContextWarning = "No navigation context has been registered.";
var NavigationContext = exports.NavigationContext = (0, _react.createContext)({
  navigate: function navigate() {
    return console.warn(missingNavigationContextWarning);
  },
  transform: function transform() {
    console.warn(missingNavigationContextWarning);
    return '';
  }
});